import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/ingresoCajas';
import Ingreso from './IngresoCajas';

const ms2p = (state) => {
  return {
    ...state.ingreso_cajas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Ingreso);
